import { adsBlueA } from "../utils/ADSColours";

const StreetClassification = [
  {
    id: 4,
    gpText: "Pedestrian way or footpath",
    colour: adsBlueA,
  },
  {
    id: 6,
    gpText: "Cycletrack or cycleway",
    colour: adsBlueA,
  },
  {
    id: 8,
    gpText: "All vehicles",
    colour: adsBlueA,
  },
  {
    id: 9,
    gpText: "Restricted byway",
    colour: adsBlueA,
  },
  {
    id: 10,
    gpText: "Bridleway",
    colour: adsBlueA,
  },
];

export default StreetClassification;
